import jsonUtils from "../util/jsonUtils";

const cartKey = "lottoCart";
const localDao = {};
localDao.getCart = () => {
    if (sessionStorage.getItem(cartKey)) {
        return JSON.parse(sessionStorage.getItem(cartKey));
    }
    return {};
};
localDao.getGameByName = (gameName) => {
    return localDao.getCart()[gameName];
};
localDao.setCart = (cart) => {
    sessionStorage.setItem(cartKey, JSON.stringify(cart));
};
localDao.saveGameToCart = (gameType, game) => {
    if (game.rows.length < 1) {
        localDao.removeFromCart([gameType.name]);
    } else {
        game.updatedAt = new Date();
        var cart = localDao.getCart();
        cart[gameType.name] = game;
        localDao.setCart(cart);
    }
};
localDao.removeFromCart = (path) => {
    var cart = localDao.getCart();
    jsonUtils.removeFromPath(path, cart);
    localDao.setCart(cart);
};

export default localDao;
